import React from 'react';
import styled from 'styled-components';

import AuthProvider from './infra/auth';
import ChatsProvider from './infra/chats';
import EventsProvider from './infra/events';
import RouterProvider from './infra/routes';
import ThemeProvider from './infra/theme';

const Container = styled.div`
  height: 100vh;
  margin: auto;
  overscroll-behavior: contain;
`;

export default () => (
  <>
    <AuthProvider>
      <ThemeProvider>
        <EventsProvider>
          <ChatsProvider>
            <Container>
              <RouterProvider />
            </Container>
          </ChatsProvider>
        </EventsProvider>
      </ThemeProvider>
    </AuthProvider>
  </>
);
